import { combineReducers } from 'redux';
import map from 'handimap-react-lib/store/reducers/mapReducer';
import directions from 'handimap-react-lib/store/reducers/directionsReducer';
import profilReducer from 'handimap-react-lib/store/reducers/profilReducer';
import layerReducer from 'handimap-react-lib/store/reducers/layerReducer';
import sideBar from 'handimap-react-lib/store/reducers/sideBarReducer';
import { alertReducer } from 'handimap-react-lib/store/reducers/alertReducer';
import { disableReducer } from 'handimap-react-lib/store/reducers/disableReducer';
import selectedFeatureReducer from 'handimap-react-lib/store/reducers/selectedFeatureReducer';
import modalReducer from 'handimap-react-lib/store/reducers/modalReducer';
import { legendReducer } from 'handimap-react-lib/store/reducers/legendReducer';
import poiListingMenuReducer from 'handimap-react-lib/store/reducers/poiListingReducer';
import { focusReducer } from 'handimap-react-lib/store/reducers/focusReducer';
import { obstacleReducer } from 'handimap-react-lib/store/reducers/obstacleReducer';

export default combineReducers({
  map,
  directions,
  profils: profilReducer,
  layerConf: layerReducer,
  sideBar,
  alert: alertReducer,
  disable: disableReducer,
  selectedFeature: selectedFeatureReducer,
  modalZone: modalReducer,
  legendList: legendReducer,
  poiListingMenuReducer: poiListingMenuReducer,
  focus: focusReducer,
  obstacle: obstacleReducer

});
